/**
 * Generated from NellieBlyCutouts.fla
 */
export function NellieBlyCutouts(this: INellieBlyCutouts) {
	const cutouts = this.cutouts;
	if (!cutouts[0] && cutouts.elementFactory) {
		cutouts[0] = cutouts.elementFactory(0,undefined);
	}
	if (cutouts[0]) {
		NellieBlyCutouts_blyBalloon_cutout.call(cutouts[0] as INellieBlyCutouts_blyBalloon_cutout);
		cutouts[0].x = 912.5;
		cutouts[0].y = 496;
		if (cutouts[0].onLayout) cutouts[0].onLayout();
	}
	if (!cutouts[1] && cutouts.elementFactory) {
		cutouts[1] = cutouts.elementFactory(1,undefined);
	}
	if (cutouts[1]) {
		NellieBlyCutouts_blyBike_cutout.call(cutouts[1] as INellieBlyCutouts_blyBike_cutout);
		cutouts[1].x = 799.5;
		cutouts[1].y = 434.5;
		if (cutouts[1].onLayout) cutouts[1].onLayout();
	}
	if (!cutouts[2] && cutouts.elementFactory) {
		cutouts[2] = cutouts.elementFactory(2,undefined);
	}
	if (cutouts[2]) {
		NellieBlyCutouts_blyBirdBack_cutout.call(cutouts[2] as INellieBlyCutouts_blyBirdBack_cutout);
		cutouts[2].x = 693.5;
		cutouts[2].y = 536;
		if (cutouts[2].onLayout) cutouts[2].onLayout();
	}
	if (!cutouts[3] && cutouts.elementFactory) {
		cutouts[3] = cutouts.elementFactory(3,undefined);
	}
	if (cutouts[3]) {
		NellieBlyCutouts_blyDrZoom_cutout.call(cutouts[3] as INellieBlyCutouts_blyDrZoom_cutout);
		cutouts[3].x = 885.5;
		cutouts[3].y = 625;
		if (cutouts[3].onLayout) cutouts[3].onLayout();
	}
	if (!cutouts[4] && cutouts.elementFactory) {
		cutouts[4] = cutouts.elementFactory(4,undefined);
	}
	if (cutouts[4]) {
		NellieBlyCutouts_blyDrZoom1_cutout.call(cutouts[4] as INellieBlyCutouts_blyDrZoom1_cutout);
		cutouts[4].x = 885.5;
		cutouts[4].y = 625;
		if (cutouts[4].onLayout) cutouts[4].onLayout();
	}
	if (!cutouts[5] && cutouts.elementFactory) {
		cutouts[5] = cutouts.elementFactory(5,undefined);
	}
	if (cutouts[5]) {
		NellieBlyCutouts_blyDuck_cutout.call(cutouts[5] as INellieBlyCutouts_blyDuck_cutout);
		cutouts[5].x = 751;
		cutouts[5].y = 463.5;
		if (cutouts[5].onLayout) cutouts[5].onLayout();
	}
	if (!cutouts[6] && cutouts.elementFactory) {
		cutouts[6] = cutouts.elementFactory(6,undefined);
	}
	if (cutouts[6]) {
		NellieBlyCutouts_blyGust_cutout.call(cutouts[6] as INellieBlyCutouts_blyGust_cutout);
		cutouts[6].x = 450;
		cutouts[6].y = 557;
		if (cutouts[6].onLayout) cutouts[6].onLayout();
	}
	if (!cutouts[7] && cutouts.elementFactory) {
		cutouts[7] = cutouts.elementFactory(7,undefined);
	}
	if (cutouts[7]) {
		NellieBlyCutouts_blyKite_cutout.call(cutouts[7] as INellieBlyCutouts_blyKite_cutout);
		cutouts[7].x = 781.5;
		cutouts[7].y = 435.5;
		if (cutouts[7].onLayout) cutouts[7].onLayout();
	}
	if (!cutouts[8] && cutouts.elementFactory) {
		cutouts[8] = cutouts.elementFactory(8,undefined);
	}
	if (cutouts[8]) {
		NellieBlyCutouts_blyLandingPad_cutout.call(cutouts[8] as INellieBlyCutouts_blyLandingPad_cutout);
		cutouts[8].x = 861.5;
		cutouts[8].y = 735.5;
		if (cutouts[8].onLayout) cutouts[8].onLayout();
	}
	if (!cutouts[9] && cutouts.elementFactory) {
		cutouts[9] = cutouts.elementFactory(9,undefined);
	}
	if (cutouts[9]) {
		NellieBlyCutouts_blyMonkeyBars_cutout.call(cutouts[9] as INellieBlyCutouts_blyMonkeyBars_cutout);
		cutouts[9].x = 726;
		cutouts[9].y = 390;
		if (cutouts[9].onLayout) cutouts[9].onLayout();
	}
	if (!cutouts[10] && cutouts.elementFactory) {
		cutouts[10] = cutouts.elementFactory(10,undefined);
	}
	if (cutouts[10]) {
		NellieBlyCutouts_blyMonkeyBars1_cutout.call(cutouts[10] as INellieBlyCutouts_blyMonkeyBars1_cutout);
		cutouts[10].x = 802.5;
		cutouts[10].y = 432;
		if (cutouts[10].onLayout) cutouts[10].onLayout();
	}
	if (!cutouts[11] && cutouts.elementFactory) {
		cutouts[11] = cutouts.elementFactory(11,undefined);
	}
	if (cutouts[11]) {
		NellieBlyCutouts_blyMoon1_cutout.call(cutouts[11] as INellieBlyCutouts_blyMoon1_cutout);
		cutouts[11].x = 871.5;
		cutouts[11].y = 616.5;
		if (cutouts[11].onLayout) cutouts[11].onLayout();
	}
	if (!cutouts[12] && cutouts.elementFactory) {
		cutouts[12] = cutouts.elementFactory(12,undefined);
	}
	if (cutouts[12]) {
		NellieBlyCutouts_blyMoon2_cutout.call(cutouts[12] as INellieBlyCutouts_blyMoon2_cutout);
		cutouts[12].x = 807.5;
		cutouts[12].y = 637;
		if (cutouts[12].onLayout) cutouts[12].onLayout();
	}
	if (!cutouts[13] && cutouts.elementFactory) {
		cutouts[13] = cutouts.elementFactory(13,undefined);
	}
	if (cutouts[13]) {
		NellieBlyCutouts_blyMoon3_cutout.call(cutouts[13] as INellieBlyCutouts_blyMoon3_cutout);
		cutouts[13].x = 703.5;
		cutouts[13].y = 447.5;
		if (cutouts[13].onLayout) cutouts[13].onLayout();
	}
	if (!cutouts[14] && cutouts.elementFactory) {
		cutouts[14] = cutouts.elementFactory(14,undefined);
	}
	if (cutouts[14]) {
		NellieBlyCutouts_blyPlayground1_cutout.call(cutouts[14] as INellieBlyCutouts_blyPlayground1_cutout);
		cutouts[14].x = 716;
		cutouts[14].y = 270;
		if (cutouts[14].onLayout) cutouts[14].onLayout();
	}
	if (!cutouts[15] && cutouts.elementFactory) {
		cutouts[15] = cutouts.elementFactory(15,undefined);
	}
	if (cutouts[15]) {
		NellieBlyCutouts_blyPlayground2_cutout.call(cutouts[15] as INellieBlyCutouts_blyPlayground2_cutout);
		cutouts[15].x = 867.5;
		cutouts[15].y = 695.5;
		if (cutouts[15].onLayout) cutouts[15].onLayout();
	}
	if (!cutouts[16] && cutouts.elementFactory) {
		cutouts[16] = cutouts.elementFactory(16,undefined);
	}
	if (cutouts[16]) {
		NellieBlyCutouts_blyPlayground3_cutout.call(cutouts[16] as INellieBlyCutouts_blyPlayground3_cutout);
		cutouts[16].x = 896.5;
		cutouts[16].y = 626;
		if (cutouts[16].onLayout) cutouts[16].onLayout();
	}
	if (!cutouts[17] && cutouts.elementFactory) {
		cutouts[17] = cutouts.elementFactory(17,undefined);
	}
	if (cutouts[17]) {
		NellieBlyCutouts_blyPlayground4_cutout.call(cutouts[17] as INellieBlyCutouts_blyPlayground4_cutout);
		cutouts[17].x = 789;
		cutouts[17].y = 744;
		if (cutouts[17].onLayout) cutouts[17].onLayout();
	}
	if (!cutouts[18] && cutouts.elementFactory) {
		cutouts[18] = cutouts.elementFactory(18,undefined);
	}
	if (cutouts[18]) {
		NellieBlyCutouts_blyPyramid_cutout.call(cutouts[18] as INellieBlyCutouts_blyPyramid_cutout);
		cutouts[18].x = 86.55;
		cutouts[18].y = 510.4;
		if (cutouts[18].onLayout) cutouts[18].onLayout();
	}
	if (!cutouts[19] && cutouts.elementFactory) {
		cutouts[19] = cutouts.elementFactory(19,undefined);
	}
	if (cutouts[19]) {
		NellieBlyCutouts_blyRollerskate_cutout.call(cutouts[19] as INellieBlyCutouts_blyRollerskate_cutout);
		cutouts[19].x = 705;
		cutouts[19].y = 425.5;
		if (cutouts[19].onLayout) cutouts[19].onLayout();
	}
	if (!cutouts[20] && cutouts.elementFactory) {
		cutouts[20] = cutouts.elementFactory(20,undefined);
	}
	if (cutouts[20]) {
		NellieBlyCutouts_blySeesaw_cutout.call(cutouts[20] as INellieBlyCutouts_blySeesaw_cutout);
		cutouts[20].x = 409.5;
		cutouts[20].y = 589;
		if (cutouts[20].onLayout) cutouts[20].onLayout();
	}
	if (!cutouts[21] && cutouts.elementFactory) {
		cutouts[21] = cutouts.elementFactory(21,undefined);
	}
	if (cutouts[21]) {
		NellieBlyCutouts_blySlideBack_cutout.call(cutouts[21] as INellieBlyCutouts_blySlideBack_cutout);
		cutouts[21].x = 639;
		cutouts[21].y = 419.5;
		if (cutouts[21].onLayout) cutouts[21].onLayout();
	}
	if (!cutouts[22] && cutouts.elementFactory) {
		cutouts[22] = cutouts.elementFactory(22,undefined);
	}
	if (cutouts[22]) {
		NellieBlyCutouts_blySlideFront_cutout.call(cutouts[22] as INellieBlyCutouts_blySlideFront_cutout);
		cutouts[22].x = 717.5;
		cutouts[22].y = 392;
		if (cutouts[22].onLayout) cutouts[22].onLayout();
	}
	if (!cutouts[23] && cutouts.elementFactory) {
		cutouts[23] = cutouts.elementFactory(23,undefined);
	}
	if (cutouts[23]) {
		NellieBlyCutouts_blySpaghetti_cutout.call(cutouts[23] as INellieBlyCutouts_blySpaghetti_cutout);
		cutouts[23].x = 390.5;
		cutouts[23].y = 291;
		if (cutouts[23].onLayout) cutouts[23].onLayout();
	}
	if (!cutouts[24] && cutouts.elementFactory) {
		cutouts[24] = cutouts.elementFactory(24,undefined);
	}
	if (cutouts[24]) {
		NellieBlyCutouts_blySwing_cutout.call(cutouts[24] as INellieBlyCutouts_blySwing_cutout);
		cutouts[24].x = 318.5;
		cutouts[24].y = 365.5;
		if (cutouts[24].onLayout) cutouts[24].onLayout();
	}
	if (!cutouts[25] && cutouts.elementFactory) {
		cutouts[25] = cutouts.elementFactory(25,undefined);
	}
	if (cutouts[25]) {
		NellieBlyCutouts_blyYBoat_cutout.call(cutouts[25] as INellieBlyCutouts_blyYBoat_cutout);
		cutouts[25].x = 636.5;
		cutouts[25].y = 322.5;
		if (cutouts[25].onLayout) cutouts[25].onLayout();
	}
	if (!cutouts[26] && cutouts.elementFactory) {
		cutouts[26] = cutouts.elementFactory(26,undefined);
	}
	if (cutouts[26]) {
		NellieBlyCutouts_blyYClimb_cutout.call(cutouts[26] as INellieBlyCutouts_blyYClimb_cutout);
		cutouts[26].x = 749;
		cutouts[26].y = 481.5;
		if (cutouts[26].onLayout) cutouts[26].onLayout();
	}
	if (!cutouts[27] && cutouts.elementFactory) {
		cutouts[27] = cutouts.elementFactory(27,undefined);
	}
	if (cutouts[27]) {
		NellieBlyCutouts_blyYDuck_cutout.call(cutouts[27] as INellieBlyCutouts_blyYDuck_cutout);
		cutouts[27].x = 667;
		cutouts[27].y = 309.45;
		if (cutouts[27].onLayout) cutouts[27].onLayout();
	}
	if (!cutouts[28] && cutouts.elementFactory) {
		cutouts[28] = cutouts.elementFactory(28,undefined);
	}
	if (cutouts[28]) {
		NellieBlyCutouts_blyYHero_cutout.call(cutouts[28] as INellieBlyCutouts_blyYHero_cutout);
		cutouts[28].x = 754;
		cutouts[28].y = 486.5;
		if (cutouts[28].onLayout) cutouts[28].onLayout();
	}
	if (!cutouts[29] && cutouts.elementFactory) {
		cutouts[29] = cutouts.elementFactory(29,undefined);
	}
	if (cutouts[29]) {
		NellieBlyCutouts_blyYHug_cutout.call(cutouts[29] as INellieBlyCutouts_blyYHug_cutout);
		cutouts[29].x = 753;
		cutouts[29].y = 456.5;
		if (cutouts[29].onLayout) cutouts[29].onLayout();
	}
	if (!cutouts[30] && cutouts.elementFactory) {
		cutouts[30] = cutouts.elementFactory(30,undefined);
	}
	if (cutouts[30]) {
		NellieBlyCutouts_blyYJetpack_cutout.call(cutouts[30] as INellieBlyCutouts_blyYJetpack_cutout);
		cutouts[30].x = 706;
		cutouts[30].y = 502.5;
		if (cutouts[30].onLayout) cutouts[30].onLayout();
	}
	if (!cutouts[31] && cutouts.elementFactory) {
		cutouts[31] = cutouts.elementFactory(31,undefined);
	}
	if (cutouts[31]) {
		NellieBlyCutouts_blyYKiss_cutout.call(cutouts[31] as INellieBlyCutouts_blyYKiss_cutout);
		cutouts[31].x = 757.5;
		cutouts[31].y = 462.5;
		if (cutouts[31].onLayout) cutouts[31].onLayout();
	}
	if (!cutouts[32] && cutouts.elementFactory) {
		cutouts[32] = cutouts.elementFactory(32,undefined);
	}
	if (cutouts[32]) {
		NellieBlyCutouts_blyYRawr_cutout.call(cutouts[32] as INellieBlyCutouts_blyYRawr_cutout);
		cutouts[32].x = 771;
		cutouts[32].y = 471.5;
		if (cutouts[32].onLayout) cutouts[32].onLayout();
	}
	if (!cutouts[33] && cutouts.elementFactory) {
		cutouts[33] = cutouts.elementFactory(33,undefined);
	}
	if (cutouts[33]) {
		NellieBlyCutouts_blyYReachout_cutout.call(cutouts[33] as INellieBlyCutouts_blyYReachout_cutout);
		cutouts[33].x = 760.5;
		cutouts[33].y = 498;
		if (cutouts[33].onLayout) cutouts[33].onLayout();
	}
	if (!cutouts[34] && cutouts.elementFactory) {
		cutouts[34] = cutouts.elementFactory(34,undefined);
	}
	if (cutouts[34]) {
		NellieBlyCutouts_blyYSeesaw_cutout.call(cutouts[34] as INellieBlyCutouts_blyYSeesaw_cutout);
		cutouts[34].x = 798.5;
		cutouts[34].y = 503;
		if (cutouts[34].onLayout) cutouts[34].onLayout();
	}
	if (!cutouts[35] && cutouts.elementFactory) {
		cutouts[35] = cutouts.elementFactory(35,undefined);
	}
	if (cutouts[35]) {
		NellieBlyCutouts_blyYSlide_cutout.call(cutouts[35] as INellieBlyCutouts_blyYSlide_cutout);
		cutouts[35].x = 791;
		cutouts[35].y = 486;
		if (cutouts[35].onLayout) cutouts[35].onLayout();
	}
	if (!cutouts[36] && cutouts.elementFactory) {
		cutouts[36] = cutouts.elementFactory(36,undefined);
	}
	if (cutouts[36]) {
		NellieBlyCutouts_blyYSnack_cutout.call(cutouts[36] as INellieBlyCutouts_blyYSnack_cutout);
		cutouts[36].x = 735.5;
		cutouts[36].y = 463.5;
		if (cutouts[36].onLayout) cutouts[36].onLayout();
	}
	if (!cutouts[37] && cutouts.elementFactory) {
		cutouts[37] = cutouts.elementFactory(37,undefined);
	}
	if (cutouts[37]) {
		NellieBlyCutouts_blyYSnackDrzoom_cutout.call(cutouts[37] as INellieBlyCutouts_blyYSnackDrzoom_cutout);
		cutouts[37].x = 904;
		cutouts[37].y = 689.5;
		if (cutouts[37].onLayout) cutouts[37].onLayout();
	}
	if (!cutouts[38] && cutouts.elementFactory) {
		cutouts[38] = cutouts.elementFactory(38,undefined);
	}
	if (cutouts[38]) {
		NellieBlyCutouts_blyYSwing_cutout.call(cutouts[38] as INellieBlyCutouts_blyYSwing_cutout);
		cutouts[38].x = 158;
		cutouts[38].y = 274;
		if (cutouts[38].onLayout) cutouts[38].onLayout();
	}
	if (!cutouts[39] && cutouts.elementFactory) {
		cutouts[39] = cutouts.elementFactory(39,undefined);
	}
	if (cutouts[39]) {
		NellieBlyCutouts_blyPizzastairs_cutout.call(cutouts[39] as INellieBlyCutouts_blyPizzastairs_cutout);
		cutouts[39].x = 527;
		cutouts[39].y = 400;
		if (cutouts[39].onLayout) cutouts[39].onLayout();
	}
	if (!cutouts[40] && cutouts.elementFactory) {
		cutouts[40] = cutouts.elementFactory(40,undefined);
	}
	if (cutouts[40]) {
		NellieBlyCutouts_blyLadder_cutout.call(cutouts[40] as INellieBlyCutouts_blyLadder_cutout);
		cutouts[40].x = 807.5;
		cutouts[40].y = 444;
		if (cutouts[40].onLayout) cutouts[40].onLayout();
	}
	if (!cutouts[41] && cutouts.elementFactory) {
		cutouts[41] = cutouts.elementFactory(41,undefined);
	}
	if (cutouts[41]) {
		NellieBlyCutouts_blyPlaygroundBg_cutout.call(cutouts[41] as INellieBlyCutouts_blyPlaygroundBg_cutout);
		cutouts[41].x = 170;
		cutouts[41].y = 269;
		if (cutouts[41].onLayout) cutouts[41].onLayout();
	}
	return this;
}
function NellieBlyCutouts_blyBalloon_cutout(this: INellieBlyCutouts_blyBalloon_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [186.00,-2.95,227.20,41.25,239.65,92.05,225.30,151.50,184.05,204.25,134.20,230.05,96.65,233.10,61.35,431.40,39.30,436.20,24.30,474.50,38.15,503.65,73.85,526.80,75.75,556.00,37.40,556.00,-3.85,523.40,-16.30,485.05,-10.45,441.50,5.75,412.20,22.05,412.20,56.60,250.20,47.95,239.65,45.10,212.80,16.30,183.15,2.90,127.50,10.00,72.50,33.55,27.90,77.15,-3.35,131.75,-16.35];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyBalloon.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 223.00;
	sprite.height = 544.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol1(this: INellieBlyCutouts_Symbol1) {
	return this;
}
function NellieBlyCutouts_blyBalloon(this: INellieBlyCutouts_blyBalloon) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-balloon.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyBike_cutout(this: INellieBlyCutouts_blyBike_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [316.90,-8.60,376.60,16.40,424.75,69.40,445.95,121.40,450.25,167.70,441.15,191.70,416.10,196.50,410.30,218.65,424.75,228.30,427.65,258.15,417.05,270.70,413.30,305.20,373.70,357.35,351.55,390.10,314.95,398.80,330.40,420.95,359.30,423.85,378.05,454.50,448.40,454.75,464.25,471.05,463.30,512.40,451.75,543.20,424.75,553.80,434.90,578.85,433.45,621.25,400.70,660.70,354.45,665.55,319.80,648.20,307.25,671.30,248.50,684.80,189.75,677.10,169.55,666.50,129.05,662.65,95.35,633.75,85.75,582.70,101.15,547.05,119.80,529.95,156.05,520.10,153.00,469.85,163.00,430.35,179.15,390.05,158.95,382.35,125.20,384.25,106.90,361.15,92.45,361.15,88.60,321.65,75.15,299.50,51.05,297.60,34.70,263.85,34.20,223.30,0.95,210.00,-19.75,166.45,-8.65,125.20,-2.80,108.25,52.00,94.40,80.95,46.25,123.35,10.60,176.30,-9.65,250.45,-17.90];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyBike.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 449.00;
	sprite.height = 667.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol2(this: INellieBlyCutouts_Symbol2) {
	return this;
}
function NellieBlyCutouts_blyBike(this: INellieBlyCutouts_blyBike) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-bike.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyBirdBack_cutout(this: INellieBlyCutouts_blyBirdBack_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [446.25,256.55,450.20,230.05,468.50,195.55,475.85,166.20,519.00,110.90,558.55,65.85,581.80,-0.95,596.30,-10.65,617.60,-11.60,628.25,10.65,646.65,12.60,650.50,37.75,664.05,43.55,663.10,72.60,673.75,81.35,671.85,102.00,665.05,113.25,666.00,142.30,646.70,159.05,647.60,178.15,636.00,188.80,634.10,209.75,623.40,221.70,589.55,321.40,582.45,330.65,599.30,342.50,604.75,358.40,601.30,383.65,567.10,389.10,554.70,398.55,540.65,428.35,506.10,439.70,428.30,458.55,357.90,454.60,342.55,466.45,306.35,466.45,272.90,474.30,232.20,474.40,203.20,457.95,202.25,429.75,253.80,395.55,180.50,366.95,121.40,316.75,98.20,292.45,56.05,258.75,39.20,242.35,13.65,234.50,10.45,219.05,-9.80,209.15,-8.85,180.45,1.50,177.45,3.50,153.65,21.85,144.25,23.85,122.95,45.15,121.45,73.85,127.25,59.55,97.15,60.00,68.90,91.05,67.80,137.85,110.05,142.30,77.30,170.25,76.85,196.25,118.45,229.95,166.05,260.20,192.80,317.25,211.15,383.15,257.25,429.35,300.70];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyBirdBack.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 661.00;
	sprite.height = 464.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol3(this: INellieBlyCutouts_Symbol3) {
	return this;
}
function NellieBlyCutouts_blyBirdBack(this: INellieBlyCutouts_blyBirdBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-bird-back.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyDrZoom_cutout(this: INellieBlyCutouts_blyDrZoom_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [275.70,-2.75,291.55,27.55,289.65,81.35,272.75,113.95,239.20,115.25,220.20,133.30,218.85,167.10,203.30,188.35,209.55,214.00,199.65,236.05,182.65,245.30,171.90,265.15,127.90,275.40,103.20,264.70,74.40,289.70,43.85,302.80,9.45,291.55,0.65,262.75,8.80,240.25,-11.85,225.85,-16.20,192.70,3.80,142.65,53.20,95.15,97.65,83.25,143.95,86.35,158.35,31.30,187.75,-5.60,228.35,-16.25];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyDrZoom.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 277.00;
	sprite.height = 286.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol4(this: INellieBlyCutouts_Symbol4) {
	return this;
}
function NellieBlyCutouts_blyDrZoom(this: INellieBlyCutouts_blyDrZoom) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-dr-zoom.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyDrZoom1_cutout(this: INellieBlyCutouts_blyDrZoom1_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [0.60,-2.50,-15.25,27.80,-13.35,81.60,3.55,114.20,37.10,115.50,56.10,133.55,57.45,167.35,73.00,188.60,66.75,214.25,76.65,236.30,93.65,245.55,104.40,265.40,148.40,275.65,173.10,264.95,201.90,289.95,232.45,303.05,266.85,291.80,275.65,263.00,267.50,240.50,288.15,226.10,292.50,192.95,272.50,142.90,223.10,95.40,178.65,83.50,132.35,86.60,117.95,31.55,88.55,-5.35,47.95,-16.00];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyDrZoom1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 277.00;
	sprite.height = 286.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol5(this: INellieBlyCutouts_Symbol5) {
	return this;
}
function NellieBlyCutouts_blyDrZoom1(this: INellieBlyCutouts_blyDrZoom1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-dr-zoom-1.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyDuck_cutout(this: INellieBlyCutouts_blyDuck_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [110.25,196.80,67.65,143.05,36.80,144.00,17.45,171.80,12.30,207.60,-8.15,218.50,-16.15,265.85,-6.70,332.25,10.05,404.40,53.10,461.35,105.55,498.45,147.15,514.55,144.25,611.50,185.10,626.80,227.40,626.10,265.30,608.60,272.70,515.05,330.60,496.80,384.75,455.40,405.20,407.30,406.45,368.80,400.60,324.50,473.60,312.25,526.80,289.10,554.65,260.80,558.25,224.35,552.45,198.85,529.15,190.10,488.85,196.95,505.80,145.65,503.65,101.25,487.20,56.25,449.55,13.60,390.65,-11.35,313.25,-18.15,253.45,-3.10,209.55,29.45,184.30,70.55,177.25,126.60,183.15,183.70,142.75,182.75];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyDuck.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 546.00;
	sprite.height = 609.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol6(this: INellieBlyCutouts_Symbol6) {
	return this;
}
function NellieBlyCutouts_blyDuck(this: INellieBlyCutouts_blyDuck) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-duck.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyGust_cutout(this: INellieBlyCutouts_blyGust_cutout) {
	const sprite = this.sprite;
	NellieBlyCutouts_blyGust.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1148.00;
	sprite.height = 422.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_blyGust(this: INellieBlyCutouts_blyGust) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-gust.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyKite_cutout(this: INellieBlyCutouts_blyKite_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [470.90,-13.95,493.45,-11.40,495.15,19.90,384.25,230.00,302.65,271.25,270.55,357.60,212.45,459.25,151.30,534.80,101.65,575.40,62.65,574.65,39.75,586.90,29.05,603.70,30.60,629.70,40.50,651.10,39.00,677.05,3.05,678.60,-13.00,641.15,-13.00,585.35,12.25,549.45,42.70,532.30,74.85,530.75,133.75,482.95,184.20,416.45,227.75,345.35,249.90,299.50,81.25,376.30,51.70,377.75,51.65,344.15,216.65,20.55];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyKite.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 485.00;
	sprite.height = 665.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol7(this: INellieBlyCutouts_Symbol7) {
	return this;
}
function NellieBlyCutouts_blyKite(this: INellieBlyCutouts_blyKite) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-kite.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyLandingPad_cutout(this: INellieBlyCutouts_blyLandingPad_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [53.25,-12.65,204.35,-16.95,284.10,-13.95,324.40,-3.10,332.55,24.30,331.80,59.85,318.20,69.65,252.40,72.00,205.65,76.90,123.85,77.95,48.00,70.45,-7.90,57.90,-7.35,23.85,2.50,19.00,9.85,-2.95];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyLandingPad.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 325.00;
	sprite.height = 65.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol8(this: INellieBlyCutouts_Symbol8) {
	return this;
}
function NellieBlyCutouts_blyLandingPad(this: INellieBlyCutouts_blyLandingPad) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-landing-pad.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyMonkeyBars_cutout(this: INellieBlyCutouts_blyMonkeyBars_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [712.15,2.75,711.95,29.20,286.35,351.85,286.35,615.40,297.15,618.35,295.80,650.80,252.90,654.70,209.65,653.75,208.65,622.25,222.40,618.35,220.45,349.85,248.95,298.80,281.40,278.15,354.20,220.10,375.80,206.35,448.60,153.25,467.25,140.45,536.10,87.35,549.90,78.50,619.10,23.05,668.65,-9.65,695.45,-10.00];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [474.50,-10.65,489.65,2.00,488.40,22.85,631.70,22.85,557.85,75.25,429.05,73.95,407.55,87.25,544.60,87.85,479.55,136.50,343.80,135.85,320.45,150.35,458.10,151.65,391.80,202.75,256.70,201.45,227.65,218.50,365.25,223.55,293.30,275.95,164.50,274.05,132.30,296.15,264.90,298.05,222.60,350.45,67.95,352.95,68.55,601.10,81.80,606.80,80.25,632.65,42.05,638.35,-6.45,635.80,-7.85,609.30,4.15,605.50,4.15,337.80,9.85,314.45,449.25,-11.25];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyMonkeyBars.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 701.00;
	sprite.height = 641.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol40(this: INellieBlyCutouts_Symbol40) {
	return this;
}
function NellieBlyCutouts_Symbol41(this: INellieBlyCutouts_Symbol41) {
	return this;
}
function NellieBlyCutouts_blyMonkeyBars(this: INellieBlyCutouts_blyMonkeyBars) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-monkey-bars.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyMonkeyBars1_cutout(this: INellieBlyCutouts_blyMonkeyBars1_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [184.75,42.40,196.25,33.45,223.55,37.25,529.55,343.10,531.60,356.00,532.90,564.60,539.60,567.70,540.55,591.50,509.20,594.70,474.65,589.55,474.00,564.65,481.70,560.75,481.05,370.05,378.00,357.90,348.60,311.15,438.85,320.15,418.35,300.30,332.55,290.05,281.35,239.50,372.25,252.95,354.35,236.95,264.10,222.20,209.05,170.35,310.20,187.65,292.90,172.30,195.60,153.10,147.60,106.35,246.20,124.90,236.60,112.75,132.25,91.00,64.40,30.85,186.00,57.10];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [32.20,-10.05,78.85,32.65,202.90,156.70,218.75,169.60,275.30,223.15,288.20,240.05,366.60,314.45,386.45,362.10,382.50,572.45,392.30,576.70,391.45,599.25,354.70,607.20,318.00,601.25,317.00,571.45,326.90,568.50,331.75,353.25,-9.75,21.15,-12.15,-2.30,2.85,-15.60];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyMonkeyBars1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 531.00;
	sprite.height = 594.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol42(this: INellieBlyCutouts_Symbol42) {
	return this;
}
function NellieBlyCutouts_Symbol43(this: INellieBlyCutouts_Symbol43) {
	return this;
}
function NellieBlyCutouts_blyMonkeyBars1(this: INellieBlyCutouts_blyMonkeyBars1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-monkey-bars-1.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyMoon1_cutout(this: INellieBlyCutouts_blyMoon1_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [242.25,6.90,290.50,52.20,321.05,132.00,308.20,220.60,260.00,282.65,196.00,316.10,100.45,315.10,24.65,271.80,-14.75,192.05,-10.80,101.45,36.45,21.70,100.45,-11.75,136.55,-13.35,173.35,-15.75];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyMoon1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 305.00;
	sprite.height = 303.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol11(this: INellieBlyCutouts_Symbol11) {
	return this;
}
function NellieBlyCutouts_blyMoon1(this: INellieBlyCutouts_blyMoon1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-moon-1.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyMoon2_cutout(this: INellieBlyCutouts_blyMoon2_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [352.90,29.95,380.50,34.65,409.45,48.85,442.70,63.90,445.70,100.00,386.90,134.85,335.60,143.35,229.25,178.05,195.40,195.35,163.10,237.80,138.65,262.70,102.45,277.20,75.70,269.30,54.40,178.80,26.05,185.05,6.05,178.70,-4.70,122.10,-0.75,64.60,-11.75,43.30,-10.20,15.00,27.45,11.95,48.60,20.40,58.30,-8.65,88.25,-14.15,129.30,-0.25,188.15,43.95];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyMoon2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 433.00;
	sprite.height = 262.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol12(this: INellieBlyCutouts_Symbol12) {
	return this;
}
function NellieBlyCutouts_blyMoon2(this: INellieBlyCutouts_blyMoon2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-moon-2.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyMoon3_cutout(this: INellieBlyCutouts_blyMoon3_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [454.05,4.65,551.30,67.95,628.55,166.80,653.25,261.00,660.05,357.30,630.70,465.45,568.30,555.95,495.75,617.70,387.65,659.40,267.20,654.75,139.95,616.45,42.00,517.25,-8.00,407.70,-17.80,264.40,37.10,120.45,122.05,35.55,223.95,-4.60,335.15,-18.50];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyMoon3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 641.00;
	sprite.height = 641.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol13(this: INellieBlyCutouts_Symbol13) {
	return this;
}
function NellieBlyCutouts_blyMoon3(this: INellieBlyCutouts_blyMoon3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-moon-3.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyPlayground1_cutout(this: INellieBlyCutouts_blyPlayground1_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [621.20,953.45,617.50,988.60,571.30,993.35,521.45,989.70,516.00,956.40,531.10,953.85,531.10,817.50,404.45,818.30,402.25,968.00,417.80,972.35,414.45,1006.75,364.95,1010.45,317.90,1005.25,314.20,976.60,330.75,969.45,331.45,818.30,259.95,819.00,258.50,943.45,273.40,950.15,269.10,980.75,218.25,983.65,169.00,977.00,167.55,941.95,191.35,935.25,190.65,818.30,68.45,817.55,63.95,1000.10,-10.80,996.00,-11.30,966.10,3.20,960.80,7.45,839.20,15.30,509.60,257.50,486.80,339.50,480.25,405.10,518.75,539.25,510.05,602.80,507.95,600.45,949.25];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [353.15,-13.15,368.60,1.70,375.30,23.30,373.10,43.40,621.15,362.90,622.65,392.70,603.25,406.80,602.85,523.15,539.75,521.00,541.00,412.90,405.70,427.55,404.05,531.55,339.05,492.15,339.85,433.65,259.10,443.40,257.05,503.10,197.35,510.00,197.35,440.55,81.55,419.40,78.25,519.45,14.75,521.50,17.35,404.75,0.10,394.45,-4.65,375.60,-2.50,346.80,285.90,44.90,283.70,23.25,289.65,-2.10,319.70,-17.75];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyPlayground1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 616.00;
	sprite.height = 996.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol14(this: INellieBlyCutouts_Symbol14) {
	return this;
}
function NellieBlyCutouts_Symbol45(this: INellieBlyCutouts_Symbol45) {
	return this;
}
function NellieBlyCutouts_blyPlayground1(this: INellieBlyCutouts_blyPlayground1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-playground-1.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyPlayground2_cutout(this: INellieBlyCutouts_blyPlayground2_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [74.70,-7.85,77.85,10.90,109.75,18.60,174.85,19.40,193.30,25.55,208.60,19.20,259.00,19.80,269.45,27.15,271.70,51.10,320.25,62.55,327.25,81.05,323.65,102.10,303.00,107.20,216.50,110.70,234.45,128.25,216.70,146.65,110.55,153.90,23.55,128.60,18.30,112.10,33.80,103.40,46.55,67.35,-9.55,47.90,-12.75,17.90,12.75,7.70,13.40,-7.60,42.75,-13.35];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyPlayground2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 313.00;
	sprite.height = 145.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol15(this: INellieBlyCutouts_Symbol15) {
	return this;
}
function NellieBlyCutouts_blyPlayground2(this: INellieBlyCutouts_blyPlayground2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-playground-2.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyPlayground3_cutout(this: INellieBlyCutouts_blyPlayground3_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [164.90,7.05,177.75,44.90,178.40,77.00,202.75,80.85,215.60,63.50,246.40,62.25,256.00,89.80,268.15,101.95,268.85,145.60,254.10,195.65,227.80,228.35,192.50,244.40,193.75,289.35,158.50,301.50,125.80,291.85,120.65,246.95,90.50,236.05,61.60,203.35,59.70,159.10,17.35,147.60,-10.20,128.95,-11.50,91.10,13.50,82.10,10.95,46.20,27.00,9.65,70.60,-12.20,120.00,-16.00];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyPlayground3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 255.00;
	sprite.height = 284.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol16(this: INellieBlyCutouts_Symbol16) {
	return this;
}
function NellieBlyCutouts_blyPlayground3(this: INellieBlyCutouts_blyPlayground3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-playground-3.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyPlayground4_cutout(this: INellieBlyCutouts_blyPlayground4_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [233.40,-16.05,433.75,-12.45,442.25,7.25,462.30,13.65,471.15,25.70,477.95,39.70,466.10,54.45,413.40,59.35,367.55,55.15,360.10,40.60,126.85,41.75,116.40,58.60,54.60,64.20,-0.75,54.60,-4.55,35.35,8.85,24.10,13.25,14.45,34.55,10.45,45.40,-12.90];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyPlayground4.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 470.00;
	sprite.height = 48.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol17(this: INellieBlyCutouts_Symbol17) {
	return this;
}
function NellieBlyCutouts_blyPlayground4(this: INellieBlyCutouts_blyPlayground4) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-playground-4.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyPyramid_cutout(this: INellieBlyCutouts_blyPyramid_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [1278.40,85.55,1282.95,100.40,1421.40,224.75,1525.95,131.30,1566.10,131.65,1879.65,417.30,1881.80,449.65,1639.40,452.20,1343.60,452.20,1103.80,449.70,1107.35,476.40,1079.10,482.50,1069.40,510.85,944.70,520.80,851.00,511.80,823.70,496.65,771.05,494.00,647.70,510.15,556.35,499.65,443.90,516.25,390.65,512.80,307.75,516.30,234.20,514.25,128.30,513.70,-5.60,499.60,-6.50,469.35,93.95,439.10,150.45,405.80,209.25,351.85,322.85,362.95,351.35,422.95,397.35,403.40,700.10,83.95,731.50,84.95,894.15,249.15,1148.35,-13.55,1179.10,-11.85];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyPyramid.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1874.95;
	sprite.height = 515.25;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol18(this: INellieBlyCutouts_Symbol18) {
	return this;
}
function NellieBlyCutouts_blyPyramid(this: INellieBlyCutouts_blyPyramid) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-pyramid.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyRollerskate_cutout(this: INellieBlyCutouts_blyRollerskate_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [411.40,-6.40,471.60,25.65,503.65,61.55,582.30,17.85,622.85,15.40,645.90,37.20,656.15,96.15,640.20,146.10,540.80,151.25,534.40,170.45,573.50,187.25,581.90,223.85,569.00,270.45,540.15,297.85,508.15,298.50,481.90,329.80,452.40,353.70,467.70,374.85,469.05,420.35,430.60,481.85,440.85,549.80,472.90,563.90,479.95,610.70,467.20,679.10,394.70,679.20,372.20,703.55,242.85,668.20,235.10,590.90,258.35,557.45,261.45,495.95,231.85,475.95,204.40,424.05,205.05,372.40,224.30,347.30,187.10,317.80,138.30,319.75,102.00,286.95,92.80,235.75,110.25,202.50,132.00,196.10,128.15,167.90,16.65,192.10,-15.30,144.10,-8.95,65.35,49.50,48.05,109.20,57.05,151.25,74.35,197.50,23.75,259.75,-7.00,333.40,-18.50];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyRollerskate.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 638.00;
	sprite.height = 685.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol19(this: INellieBlyCutouts_Symbol19) {
	return this;
}
function NellieBlyCutouts_blyRollerskate(this: INellieBlyCutouts_blyRollerskate) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-rollerskate.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blySeesaw_cutout(this: INellieBlyCutouts_blySeesaw_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [182.25,104.00,201.50,114.25,204.70,147.00,458.15,127.65,479.50,104.00,634.35,109.70,947.25,82.20,947.25,60.90,897.20,57.80,879.90,41.70,879.20,3.90,904.90,-15.35,1039.60,-8.95,1062.70,2.60,1065.30,41.10,1053.75,59.60,1008.10,60.25,1006.90,75.05,1241.95,81.55,1243.70,137.40,685.40,193.90,713.65,236.05,721.20,306.00,720.05,365.85,635.35,362.00,577.55,368.30,537.10,358.65,495.45,366.90,448.60,360.65,391.75,374.75,389.00,339.90,414.55,331.20,414.60,263.90,432.65,209.80,144.25,231.60,-14.85,220.80,-12.75,170.00,103.40,156.05,77.85,145.05,78.35,107.30,107.80,97.60];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blySeesaw.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1229.00;
	sprite.height = 358.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol20(this: INellieBlyCutouts_Symbol20) {
	return this;
}
function NellieBlyCutouts_blySeesaw(this: INellieBlyCutouts_blySeesaw) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-seesaw.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blySlideBack_cutout(this: INellieBlyCutouts_blySlideBack_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [86.75,110.45,90.85,84.10,104.30,78.45,102.45,33.25,116.05,0.40,151.55,-16.60,199.80,-10.30,221.95,26.85,224.95,67.65,226.05,103.25,288.80,173.45,368.50,282.80,459.90,384.60,558.35,446.85,662.55,492.30,741.00,519.10,776.30,554.20,785.40,606.85,785.80,674.75,742.05,683.20,742.40,703.25,652.20,706.95,647.90,690.00,434.25,713.75,325.05,666.70,186.80,544.90,91.85,391.15,40.30,263.20,8.30,176.50,-11.85,146.60,-11.30,112.55];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blySlideBack.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 770.00;
	sprite.height = 697.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol21(this: INellieBlyCutouts_Symbol21) {
	return this;
}
function NellieBlyCutouts_blySlideBack(this: INellieBlyCutouts_blySlideBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-slide-back.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blySlideFront_cutout(this: INellieBlyCutouts_blySlideFront_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [178.05,-7.25,199.30,16.65,206.70,73.65,206.60,120.00,239.10,177.35,310.30,332.50,354.00,402.55,395.20,443.70,466.30,490.90,542.00,528.75,591.20,567.25,617.75,607.75,628.40,685.50,627.70,728.65,608.50,742.60,569.95,747.90,534.05,735.30,536.05,761.90,478.25,767.20,415.15,760.55,413.15,729.35,447.05,726.00,447.00,690.15,366.40,636.05,295.95,557.95,259.95,500.30,241.20,620.80,251.05,623.70,251.70,653.60,204.55,659.60,164.15,657.45,165.15,623.05,90.00,628.50,89.45,664.60,56.50,677.50,8.00,676.20,-8.60,668.20,-6.75,640.45,6.70,637.65,76.45,169.45,65.60,160.20,65.15,114.95,73.40,99.90,74.05,57.55,81.30,18.65,103.65,-7.25,139.65,-15.65];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blySlideFront.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 613.00;
	sprite.height = 752.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol22(this: INellieBlyCutouts_Symbol22) {
	return this;
}
function NellieBlyCutouts_blySlideFront(this: INellieBlyCutouts_blySlideFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-slide-front.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blySpaghetti_cutout(this: INellieBlyCutouts_blySpaghetti_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [771.60,0.85,780.85,40.30,799.30,51.20,804.30,84.75,831.15,109.05,826.95,151.00,840.35,171.95,868.85,271.75,879.75,279.30,883.15,305.30,899.05,317.85,899.05,338.80,916.65,354.75,941.00,361.45,959.45,380.75,961.15,418.50,982.95,432.75,1001.40,476.35,1004.75,489.80,1027.40,504.05,1042.50,524.15,1047.50,556.00,1069.30,570.30,1082.75,599.65,1074.35,639.05,1095.30,649.95,1102.85,676.80,1098.70,703.65,1126.35,707.00,1159.90,720.40,1165.75,765.70,1179.15,784.95,1194.25,784.95,1208.55,805.10,1221.95,836.15,1237.90,842.85,1243.75,855.40,1279.05,865.50,1279.00,904.05,1243.75,917.50,1206.00,917.50,1171.60,930.05,1097.00,936.80,1036.60,945.15,1008.10,942.65,1005.55,926.70,956.90,937.60,907.45,929.25,868.00,943.50,817.70,938.45,799.25,925.05,722.10,935.15,685.20,935.15,657.55,947.70,625.65,944.35,603.00,955.25,530.05,960.30,496.50,972.05,448.70,964.50,434.45,942.70,397.55,941.00,366.50,932.65,334.65,937.65,263.35,927.60,260.85,941.85,233.15,946.90,181.15,938.50,80.50,930.95,62.90,919.20,-15.95,911.65,-12.55,873.90,22.65,855.45,24.35,842.85,52.00,837.00,60.40,798.40,80.55,783.35,95.65,780.80,104.00,765.70,101.50,736.35,114.90,712.90,151.00,704.50,182.85,720.40,193.75,716.25,197.95,680.15,207.20,671.80,229.00,670.10,233.10,650.80,249.05,646.60,255.75,627.35,272.55,615.60,302.70,613.10,339.65,578.70,343.00,550.15,369.80,539.25,371.50,520.80,395.80,511.60,403.40,488.95,442.80,435.25,443.65,407.60,459.60,389.15,452.90,353.10,468.80,335.45,459.60,318.70,466.30,284.30,493.15,261.65,543.45,267.55,561.90,198.80,581.20,165.25,598.00,160.20,596.30,144.25,608.05,133.35,615.15,108.55,633.20,101.50,636.50,74.10,657.35,39.25,676.00,21.80,686.90,-3.35,735.55,-16.75];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blySpaghetti.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1267.00;
	sprite.height = 954.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol23(this: INellieBlyCutouts_Symbol23) {
	return this;
}
function NellieBlyCutouts_blySpaghetti(this: INellieBlyCutouts_blySpaghetti) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-spaghetti.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blySwing_cutout(this: INellieBlyCutouts_blySwing_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [1202.40,488.65,1134.40,493.75,1169.60,50.25,1103.05,48.65,1106.30,628.75,1123.60,639.55,1125.55,688.50,862.10,692.50,853.50,645.00,878.55,626.30,875.10,52.95,922.65,50.80,926.95,624.45,1056.60,624.45,1054.55,40.50,822.15,38.90,820.00,627.70,841.60,645.00,839.75,689.95,572.80,690.75,572.60,640.65,592.05,628.80,590.95,48.65,638.50,49.70,641.75,624.45,770.30,624.45,765.95,30.25,530.45,35.65,535.85,628.80,553.15,641.75,554.90,690.70,290.90,691.55,289.50,641.70,308.95,628.75,301.40,45.40,354.35,47.60,357.60,623.65,485.85,625.45,484.00,34.60,240.90,38.95,274.40,487.25,209.55,492.65,171.75,1.15,1252.15,6.50,1233.45,72.65];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [783.80,-15.80,1060.55,-15.10,1293.75,-13.20,1315.45,0.70,1317.50,39.40,1306.65,60.45,1289.95,63.40,1425.55,788.00,1418.45,813.30,1384.35,821.15,1362.75,810.45,1308.55,531.10,1198.10,536.35,1178.95,764.75,1157.70,776.40,1129.05,770.05,1122.70,763.65,1116.30,754.10,1136.05,475.80,1295.00,462.80,1230.45,128.10,1166.95,63.80,245.35,64.20,181.05,128.00,115.75,465.30,274.10,471.70,295.80,746.35,286.75,768.40,259.55,774.85,231.95,762.35,212.95,534.80,105.15,532.15,46.80,809.85,22.30,819.45,-10.40,812.50,-13.55,787.30,-9.85,761.55,114.75,117.90,113.70,92.40,122.20,65.85,105.90,53.10,103.70,2.75,122.45,-12.90];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blySwing.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1411.00;
	sprite.height = 805.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol25(this: INellieBlyCutouts_Symbol25) {
	return this;
}
function NellieBlyCutouts_Symbol24(this: INellieBlyCutouts_Symbol24) {
	return this;
}
function NellieBlyCutouts_blySwing(this: INellieBlyCutouts_blySwing) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-swing.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYBoat_cutout(this: INellieBlyCutouts_blyYBoat_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [633.10,15.30,677.60,44.70,712.65,14.20,758.40,5.90,780.20,49.05,773.25,100.70,712.00,110.10,737.70,126.45,744.25,158.35,734.95,198.75,699.60,210.35,677.80,248.50,697.40,281.20,689.75,349.85,743.15,389.00,784.85,450.45,792.30,630.50,769.30,736.65,691.15,876.90,591.55,903.45,405.40,906.60,188.55,899.00,19.60,889.20,8.75,866.30,-11.30,843.35,-17.45,803.10,-13.95,769.95,30.50,722.45,42.50,536.10,70.85,536.10,76.30,514.35,31.60,513.25,34.45,477.50,73.00,474.00,82.85,454.40,106.80,453.30,113.35,477.30,135.55,478.20,135.15,423.90,71.95,421.70,71.70,387.95,135.15,387.90,135.20,345.45,88.30,337.85,87.65,306.85,137.35,308.40,142.35,243.05,173.15,242.80,176.60,308.40,223.45,314.95,224.30,340.00,290.35,339.80,289.90,288.80,282.50,287.70,281.20,260.45,193.85,258.70,196.00,225.80,293.60,226.90,294.30,142.35,237.40,140.35,237.40,105.95,299.55,106.35,301.65,54.30,334.60,52.35,335.70,107.90,350.95,94.85,370.55,87.20,372.10,51.65,413.05,50.15,415.40,-8.10,449.00,-7.60,453.35,57.75,470.80,57.75,502.40,28.35,577.55,10.95];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYBoat.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 775.00;
	sprite.height = 891.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol26(this: INellieBlyCutouts_Symbol26) {
	return this;
}
function NellieBlyCutouts_blyYBoat(this: INellieBlyCutouts_blyYBoat) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-boat.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYClimb_cutout(this: INellieBlyCutouts_blyYClimb_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [354.60,15.45,414.55,63.40,455.70,48.00,512.20,46.25,561.90,65.10,563.60,149.05,524.20,178.00,440.40,150.25,435.15,202.15,462.55,221.00,457.40,274.10,419.70,305.15,376.90,313.50,344.35,346.05,278.30,388.25,270.80,446.35,289.55,476.20,311.80,484.75,315.20,501.90,352.90,517.30,359.75,561.80,335.80,584.05,263.85,589.20,214.15,572.05,202.15,554.95,171.35,577.20,73.15,583.55,44.45,558.00,44.60,518.95,63.70,500.35,95.25,491.05,106.25,419.60,82.25,373.35,84.00,340.80,121.65,308.30,96.30,280.95,82.25,250.10,60.15,242.55,44.55,188.45,56.65,153.45,72.70,139.50,77.10,113.10,-6.80,99.40,-18.80,34.30,10.30,-11.95,53.15,-18.80,118.20,36.00,186.75,-6.80,282.65,-11.95];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYClimb.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 550.00;
	sprite.height = 573.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol27(this: INellieBlyCutouts_Symbol27) {
	return this;
}
function NellieBlyCutouts_blyYClimb(this: INellieBlyCutouts_blyYClimb) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-climb.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYDuck_cutout(this: INellieBlyCutouts_blyYDuck_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [271.60,87.70,320.55,88.50,300.00,56.10,301.50,18.90,366.85,-16.15,405.80,-12.60,425.55,47.40,423.20,122.45,483.95,211.75,516.75,307.00,589.40,319.80,658.50,362.40,689.15,423.85,685.30,484.00,670.75,523.60,717.50,514.40,743.75,536.90,739.40,585.55,677.60,629.40,583.45,650.60,587.40,721.65,561.55,784.30,504.20,824.40,457.90,839.30,450.80,934.85,411.35,950.60,356.85,949.05,328.45,935.60,331.20,835.35,259.00,801.70,198.20,736.65,178.45,654.55,166.60,578.75,176.15,537.30,198.15,528.10,203.95,483.40,231.20,467.10,194.55,440.00,131.45,433.25,102.75,394.95,106.40,341.60,118.45,319.75,105.85,251.10,-2.35,241.60,-18.90,181.60,3.20,125.55,68.25,122.35,137.45,163.45,174.10,125.35,221.55,98.30];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYDuck.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 729.00;
	sprite.height = 933.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol47(this: INellieBlyCutouts_Symbol47) {
	return this;
}
function NellieBlyCutouts_blyYDuck(this: INellieBlyCutouts_blyYDuck) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-duck.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYHero_cutout(this: INellieBlyCutouts_blyYHero_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [360.90,-4.70,421.75,37.55,470.95,-2.45,522.45,-16.65,554.30,24.20,550.15,96.75,463.40,112.15,462.95,125.05,489.30,135.05,505.95,149.25,509.25,193.40,488.40,234.90,453.00,242.15,438.45,273.30,412.60,300.95,431.80,319.20,442.65,360.90,433.95,404.00,411.80,444.25,416.20,470.35,429.90,477.75,433.45,494.20,466.65,500.45,483.40,526.75,476.80,562.60,437.90,577.40,365.10,572.55,338.10,557.10,325.95,529.15,286.25,567.55,226.25,581.30,169.25,571.70,155.90,550.90,161.80,510.85,198.40,494.20,205.90,480.05,230.10,468.40,190.05,406.70,176.85,384.90,180.90,356.75,212.25,316.70,184.25,301.70,145.90,305.05,113.40,289.20,95.70,257.70,95.50,215.45,120.90,195.85,111.10,177.80,42.85,209.20,7.05,206.20,-16.65,167.50,-14.15,106.35,27.55,87.50,78.30,83.50,124.25,95.85,155.05,46.70,198.35,10.90,267.60,-10.00];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYHero.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 540.00;
	sprite.height = 563.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol29(this: INellieBlyCutouts_Symbol29) {
	return this;
}
function NellieBlyCutouts_blyYHero(this: INellieBlyCutouts_blyYHero) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-hero.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYHug_cutout(this: INellieBlyCutouts_blyYHug_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [395.10,41.40,422.20,8.60,493.50,-18.50,534.85,-10.65,558.35,45.65,544.80,104.80,441.40,114.80,444.95,163.30,464.95,175.40,472.75,215.35,459.20,264.55,417.15,283.10,365.80,338.70,381.50,391.50,380.10,424.30,350.80,449.25,360.10,541.25,375.10,549.80,380.10,609.00,329.45,633.25,267.40,638.95,228.90,626.80,167.55,630.40,121.95,621.10,109.80,586.15,121.95,548.40,168.30,538.40,176.85,493.45,166.15,474.20,170.40,447.85,144.05,412.20,131.25,379.40,144.80,340.85,119.85,325.15,104.15,300.15,71.35,289.50,52.80,248.85,49.95,214.60,63.50,196.75,66.35,155.35,5.05,159.70,-16.40,100.55,-9.25,44.90,20.00,30.65,102.70,52.75,147.70,17.85,236.75,-7.15,333.75,3.60];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYHug.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 542.00;
	sprite.height = 623.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol30(this: INellieBlyCutouts_Symbol30) {
	return this;
}
function NellieBlyCutouts_blyYHug(this: INellieBlyCutouts_blyYHug) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-hug.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYJetpack_cutout(this: INellieBlyCutouts_blyYJetpack_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [39.50,390.90,40.10,391.00,40.95,390.10,50.35,298.20,77.65,189.15,100.85,171.30,104.45,153.45,13.40,160.75,-20.50,100.45,-8.00,27.60,21.45,15.15,91.05,28.60,148.20,61.60,207.75,8.15,283.80,-14.25,370.60,-13.45,447.95,16.10,494.35,66.95,581.05,20.75,629.10,14.30,650.50,41.05,648.70,109.80,622.85,155.95,524.65,158.85,522.90,173.15,547.85,189.20,555.90,237.40,527.35,289.15,490.75,298.95,458.65,334.65,478.25,349.85,467.75,388.50,465.80,422.95,442.55,437.25,360.25,435.55,328.95,435.85,283.40,544.30,252.90,560.05,210.65,564.00,170.35,623.00,141.80,618.10,117.20,645.60,98.50,646.60,80.80,679.05,65.10,678.05,44.45,693.80,15.90,694.80,8.05,673.15,22.80,646.60,26.75,599.40,13.95,558.10,32.65,501.05,23.80,486.30,13.95,419.45,40.10,391.00,39.50,390.90];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYJetpack.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 636.00;
	sprite.height = 684.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol31(this: INellieBlyCutouts_Symbol31) {
	return this;
}
function NellieBlyCutouts_blyYJetpack(this: INellieBlyCutouts_blyYJetpack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-jetpack.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYKiss_cutout(this: INellieBlyCutouts_blyYKiss_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [362.35,0.75,422.05,35.25,452.25,75.50,497.50,74.10,541.35,95.65,550.70,156.05,527.00,199.15,471.65,215.00,446.50,268.85,409.80,306.95,409.10,328.50,366.35,354.85,336.50,347.95,315.65,350.10,337.20,425.20,350.30,446.40,361.65,493.15,381.75,506.45,395.45,554.25,385.35,582.30,322.65,616.50,257.40,626.15,230.80,620.40,224.35,603.85,183.35,598.80,153.15,589.45,143.80,558.55,151.00,522.60,189.85,512.55,197.85,489.90,189.10,446.45,192.10,379.15,167.55,373.10,152.45,361.60,135.20,383.90,99.95,378.85,59.70,367.35,39.55,340.00,-6.45,336.40,-12.90,306.20,4.35,294.00,32.35,219.30,35.95,171.85,56.10,136.60,84.85,118.65,115.75,124.40,121.50,76.95,109.30,62.60,117.90,33.80,149.20,27.85,204.70,-11.50,286.90,-15.80];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYKiss.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 533.00;
	sprite.height = 611.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol32(this: INellieBlyCutouts_Symbol32) {
	return this;
}
function NellieBlyCutouts_blyYKiss(this: INellieBlyCutouts_blyYKiss) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-kiss.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYRawr_cutout(this: INellieBlyCutouts_blyYRawr_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [241.10,-13.70,250.55,1.50,299.05,8.00,356.95,31.90,397.10,78.75,415.60,155.70,432.25,155.70,453.25,144.10,484.40,147.00,490.90,178.85,477.85,194.05,474.95,231.65,515.50,264.95,522.75,297.55,490.85,349.00,435.15,357.65,396.80,311.30,366.50,337.50,342.50,351.10,354.05,457.55,362.75,516.20,374.35,523.45,377.25,581.35,337.40,602.35,284.55,611.75,239.70,600.90,188.25,604.55,141.95,593.65,129.65,564.70,136.85,531.40,158.60,519.85,179.60,516.20,186.80,498.85,164.40,490.85,154.95,448.15,157.15,413.40,166.55,372.10,178.85,349.70,128.20,320.00,76.05,388.75,17.40,380.80,-11.55,346.75,-15.20,307.65,37.70,266.40,31.20,245.45,36.30,207.75,65.20,186.45,64.85,121.20,97.50,56.60,159.00,14.60,200.60,6.55,211.45,-13.70];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYRawr.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 506.00;
	sprite.height = 593.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol33(this: INellieBlyCutouts_Symbol33) {
	return this;
}
function NellieBlyCutouts_blyYRawr(this: INellieBlyCutouts_blyYRawr) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-rawr.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYReachout_cutout(this: INellieBlyCutouts_blyYReachout_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [342.10,-8.15,399.40,28.25,422.60,70.15,501.90,57.30,540.05,74.35,539.45,132.05,512.95,172.00,475.80,168.35,464.85,219.30,496.85,234.10,503.55,279.70,482.55,314.35,424.20,306.65,360.20,337.05,379.30,463.05,408.95,467.20,427.60,488.50,429.40,528.55,399.40,544.00,346.30,546.70,309.00,539.40,286.60,528.55,250.20,547.65,189.05,556.25,149.65,543.90,140.10,503.05,156.00,481.30,182.90,472.15,185.60,453.95,208.35,447.55,218.35,403.90,217.45,341.05,193.35,336.50,173.80,321.10,101.00,322.00,77.35,300.20,81.00,253.80,99.20,241.95,80.15,221.00,74.60,186.45,38.05,204.25,1.60,184.10,-14.50,144.35,-13.15,101.80,44.75,77.85,113.75,79.20,138.30,29.15,184.70,-0.85,272.95,-19.05];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYReachout.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 527.00;
	sprite.height = 540.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol34(this: INellieBlyCutouts_Symbol34) {
	return this;
}
function NellieBlyCutouts_blyYReachout(this: INellieBlyCutouts_blyYReachout) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-reachout.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYSeesaw_cutout(this: INellieBlyCutouts_blyYSeesaw_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [283.00,14.35,323.25,26.30,361.90,-2.15,422.45,-18.20,451.65,-9.45,469.15,43.10,453.10,90.50,391.10,90.50,423.20,179.45,418.10,217.40,440.00,241.45,436.35,296.20,404.95,299.10,369.95,318.80,348.05,343.60,353.15,387.40,386.00,373.55,430.50,374.30,453.10,402.75,448.75,431.20,433.40,491.75,407.85,512.90,372.85,518.75,349.50,504.15,332.00,531.15,302.80,545.00,266.35,539.20,242.25,510.00,232.05,461.85,215.25,442.15,203.60,359.70,178.05,356.05,156.90,330.50,95.60,326.15,73.70,300.60,80.25,264.15,76.65,223.25,89.75,202.85,88.30,139.35,-2.20,138.65,-18.95,85.35,1.45,37.95,37.20,29.90,81.00,43.05,118.95,67.15,157.95,34.05,224.00,12.45];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYSeesaw.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 451.00;
	sprite.height = 530.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol35(this: INellieBlyCutouts_Symbol35) {
	return this;
}
function NellieBlyCutouts_blyYSeesaw(this: INellieBlyCutouts_blyYSeesaw) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-seesaw.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYSlide_cutout(this: INellieBlyCutouts_blyYSlide_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [262.05,69.55,243.00,30.10,268.60,0.75,312.50,-16.80,342.55,-11.70,360.85,38.10,355.00,105.40,379.65,134.35,432.70,245.50,432.25,271.30,414.25,285.40,387.65,315.00,376.70,352.10,362.15,370.90,370.60,404.75,390.10,417.90,418.55,405.90,451.60,406.20,477.20,428.90,483.05,471.35,462.55,525.50,426.70,548.90,398.15,548.90,378.40,533.55,365.25,563.55,327.80,580.45,294.00,567.35,274.60,544.35,269.35,517.45,246.55,489.35,226.90,410.60,194.80,400.35,177.25,378.85,141.15,368.85,102.45,363.85,85.55,332.45,88.60,281.05,94.80,267.85,86.05,206.00,-2.90,204.20,-16.05,161.00,-2.55,106.25,34.45,97.30,77.55,108.00,113.85,131.35,149.85,95.50,207.15,72.50];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYSlide.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 466.00;
	sprite.height = 564.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol36(this: INellieBlyCutouts_Symbol36) {
	return this;
}
function NellieBlyCutouts_blyYSlide(this: INellieBlyCutouts_blyYSlide) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-slide.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYSnack_cutout(this: INellieBlyCutouts_blyYSnack_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [384.50,2.75,433.85,48.25,468.30,20.70,531.45,11.50,584.25,22.95,594.55,79.20,573.65,138.90,507.35,134.30,470.60,129.70,472.90,165.30,494.20,181.35,491.25,241.05,470.60,276.65,435.00,284.65,407.75,311.25,379.25,329.45,404.70,365.75,408.60,422.65,394.85,447.40,404.50,523.65,420.10,539.45,420.55,591.75,377.20,618.40,320.50,626.85,280.55,616.35,220.40,624.35,168.30,609.00,161.85,568.15,177.95,540.60,215.80,530.25,221.55,483.20,188.45,477.30,172.20,439.60,172.20,390.25,197.70,347.80,162.30,328.55,133.15,296.15,102.00,287.40,81.50,259.40,74.65,219.25,84.95,199.75,81.50,171.05,89.55,147.40,0.05,148.10,-16.05,93.00,-8.15,31.00,31.00,19.55,72.75,29.95,120.55,59.70,165.85,11.55,227.25,-13.25,297.15,-18.45];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYSnack.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 577.00;
	sprite.height = 609.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol37(this: INellieBlyCutouts_Symbol37) {
	return this;
}
function NellieBlyCutouts_blyYSnack(this: INellieBlyCutouts_blyYSnack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-snack.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYSnackDrzoom_cutout(this: INellieBlyCutouts_blyYSnackDrzoom_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [256.85,38.05,250.60,82.50,231.40,96.15,209.70,103.70,206.20,117.75,243.70,121.90,255.00,149.70,220.50,162.65,192.15,154.95,148.60,161.55,81.50,172.55,52.45,161.00,18.45,169.05,-7.65,163.15,-16.20,135.20,-6.10,110.00,4.10,105.60,11.10,84.95,48.00,54.50,85.20,42.25,120.90,44.35,142.15,55.40,149.55,18.50,169.05,-6.70,204.00,-14.75,238.65,-5.80];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYSnackDrzoom.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 240.00;
	sprite.height = 157.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol38(this: INellieBlyCutouts_Symbol38) {
	return this;
}
function NellieBlyCutouts_blyYSnackDrzoom(this: INellieBlyCutouts_blyYSnackDrzoom) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-snack-drzoom.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyYSwing_cutout(this: INellieBlyCutouts_blyYSwing_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [1613.80,18.75,1605.80,64.95,1577.35,74.05,1747.05,977.60,1733.75,997.25,1698.50,1003.20,1675.45,988.90,1608.40,648.10,1467.35,654.65,1446.35,933.20,1427.35,947.20,1384.20,940.50,1376.35,914.20,1398.35,586.10,1595.05,572.75,1512.85,146.95,1438.50,74.35,294.80,73.75,223.45,140.60,135.65,575.40,330.10,581.10,358.10,924.20,345.10,942.20,306.80,945.55,288.10,927.20,264.10,653.15,124.05,648.15,54.05,988.20,33.15,1002.00,-4.00,996.25,-13.00,967.20,155.10,75.05,131.75,53.65,129.05,10.20,149.95,-13.15,1595.85,-13.50];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [1471.80,589.50,1398.40,598.40,1437.95,54.85,1347.60,50.80,1354.85,774.20,1374.20,792.75,1377.45,832.25,1361.30,844.35,1063.55,844.85,1053.25,820.15,1029.90,819.35,996.00,854.85,946.00,875.00,899.25,868.55,881.50,850.00,875.85,827.45,867.80,850.00,846.80,866.95,800.15,870.20,758.90,847.60,735.50,821.80,680.65,819.40,677.45,838.75,660.50,844.40,371.75,845.20,359.65,830.70,357.25,799.25,382.25,777.45,377.70,62.90,294.35,60.50,331.45,598.40,261.65,601.60,216.90,30.65,433.05,27.45,434.65,771.80,600.00,771.80,600.00,479.85,573.40,479.85,547.60,434.70,549.20,374.20,599.20,357.25,592.75,38.75,649.20,38.75,651.65,358.95,691.95,376.70,712.90,346.05,726.65,35.55,780.65,36.35,769.40,306.50,830.65,287.15,894.40,289.60,964.55,317.00,941.15,34.75,999.25,33.10,1022.60,368.60,1080.70,350.85,1078.25,37.95,1132.10,37.05,1132.30,352.45,1150.70,395.45,1134.55,447.10,1134.70,771.80,1300.80,770.75,1296.80,33.10,1489.55,31.50,1506.05,144.35];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyYSwing.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1732.00;
	sprite.height = 988.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol28(this: INellieBlyCutouts_Symbol28) {
	return this;
}
function NellieBlyCutouts_Symbol48(this: INellieBlyCutouts_Symbol48) {
	return this;
}
function NellieBlyCutouts_blyYSwing(this: INellieBlyCutouts_blyYSwing) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-swing.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyPizzastairs_cutout(this: INellieBlyCutouts_blyPizzastairs_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [343.00,4.10,395.40,21.30,402.75,48.30,375.75,73.70,371.65,125.25,387.20,196.45,375.40,220.90,446.15,216.95,568.95,234.15,623.60,257.90,622.05,290.40,604.15,301.25,570.70,304.55,561.55,369.20,656.55,362.60,757.95,380.65,804.65,395.35,810.35,427.30,790.70,442.85,780.90,494.40,807.90,559.90,902.05,556.65,968.35,564.80,1006.80,587.75,1008.15,612.10,1000.25,625.40,999.50,673.70,1008.50,704.00,991.30,740.00,888.15,752.30,725.25,746.55,705.60,735.05,670.40,732.60,658.10,721.95,564.00,719.55,497.70,715.45,481.30,707.25,310.85,699.90,286.20,687.05,203.55,696.65,177.10,692.00,175.95,676.40,18.05,672.85,-8.95,659.75,-11.45,631.95,9.05,602.45,53.25,577.10,59.80,556.65,36.85,541.10,36.05,508.35,57.30,482.15,83.50,379.00,74.55,369.15,72.90,341.35,78.65,289.75,87.95,237.55,78.45,193.20,84.30,162.10,75.30,119.55,78.60,65.50,40.95,58.95,36.00,40.10,40.10,18.85,106.40,-6.55,225.95,-13.90];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyPizzastairs.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 994.00;
	sprite.height = 736.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol9(this: INellieBlyCutouts_Symbol9) {
	return this;
}
function NellieBlyCutouts_blyPizzastairs(this: INellieBlyCutouts_blyPizzastairs) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-pizzastairs.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyLadder_cutout(this: INellieBlyCutouts_blyLadder_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [-1.95,-9.90,35.90,-10.60,59.15,36.60,83.75,101.70,95.70,129.65,131.60,227.90,151.55,288.40,186.75,386.05,200.05,419.30,233.95,516.35,251.90,574.15,269.15,620.65,265.85,649.90,248.55,659.20,222.00,658.55,204.75,634.65,-13.25,12.65];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [196.75,69.10,196.00,51.70,208.05,41.85,231.05,40.75,246.00,55.85,442.65,601.70,444.45,628.40,430.65,645.90,401.40,644.60,388.80,626.65,367.80,575.85,240.60,572.15,219.05,517.40,353.30,520.75,339.60,483.75,207.40,475.15,186.75,418.60,319.65,427.25,307.65,395.45,174.10,381.40,154.85,326.25,291.60,341.40,277.10,303.00,138.90,282.40,118.30,226.65,258.35,248.15,243.95,211.35,105.70,184.75,83.50,129.05,222.00,153.35,211.10,126.00,73.35,96.30,48.55,37.20];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyLadder.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 433.00;
	sprite.height = 648.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol10(this: INellieBlyCutouts_Symbol10) {
	return this;
}
function NellieBlyCutouts_Symbol44(this: INellieBlyCutouts_Symbol44) {
	return this;
}
function NellieBlyCutouts_blyLadder(this: INellieBlyCutouts_blyLadder) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-ladder.png", 0.000, 0.000);
	return this;
}
function NellieBlyCutouts_blyPlaygroundBg_cutout(this: INellieBlyCutouts_blyPlaygroundBg_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [505.15,6.40,548.25,8.80,564.20,59.85,597.75,63.85,608.90,130.10,644.80,150.05,646.40,178.75,722.20,181.15,739.00,206.70,742.15,237.80,815.60,227.45,860.30,258.55,865.05,288.90,932.10,273.75,972.00,314.45,980.80,353.55,1011.10,351.10,1075.70,417.20,1068.55,484.40,1038.25,496.35,1025.45,551.40,1037.10,570.80,1024.65,604.10,1009.50,608.90,1006.30,633.60,978.40,652.00,935.30,670.35,891.40,663.95,885.80,688.70,850.70,694.25,833.95,773.30,855.50,773.30,865.85,739.75,902.55,742.15,927.30,767.70,977.60,765.30,995.95,778.85,1009.50,760.50,1033.45,754.90,1071.75,701.45,1100.50,702.25,1155.55,756.50,1174.70,741.35,1232.15,739.75,1253.70,770.10,1341.50,782.85,1362.25,822.75,1393.40,814.00,1432.85,832.40,1487.55,807.60,1542.60,814.00,1570.55,854.70,1613.65,849.10,1659.10,873.75,1700.10,912.50,1715.20,946.15,1716.60,971.20,1686.25,996.75,1541.80,999.15,1348.70,994.35,1272.85,999.15,1241.75,995.15,962.45,996.75,936.90,1003.90,901.75,1001.55,789.25,1007.90,735.75,1002.35,668.75,1006.30,608.90,998.35,454.95,997.55,301.70,995.95,275.35,1001.55,244.25,996.75,197.15,995.95,155.65,1003.15,68.70,988.75,21.60,984.00,8.00,965.60,8.80,940.90,35.95,921.75,62.30,858.65,79.05,855.45,87.00,834.70,126.15,792.40,159.65,795.60,178.80,773.25,198.75,771.70,209.90,761.30,233.05,761.30,267.40,798.00,284.15,813.15,323.25,807.60,354.35,772.45,359.95,743.75,373.50,741.35,396.65,723.00,412.60,705.45,440.55,703.85,434.95,654.40,410.20,659.95,375.10,648.00,371.90,625.90,387.65,593.50,344.80,575.40,337.60,586.55,290.50,581.75,273.75,604.90,246.60,606.50,205.10,569.80,183.55,580.95,158.00,579.35,138.85,555.40,142.85,517.10,116.50,520.30,91.00,510.70,82.20,478.80,56.65,486.75,35.10,482.00,20.75,447.65,4.00,437.30,-4.80,399.00,2.40,384.60,-11.95,359.95,0.00,284.90,19.20,279.35,47.90,281.75,57.50,275.35,20.75,225.05,-3.95,213.10,-7.15,162.80,13.60,150.85,12.00,119.75,53.50,31.15,87.80,20.00,134.10,51.10,165.20,45.55,213.10,84.65,232.25,79.85,249.80,54.30,292.90,59.10,312.05,39.95,344.00,39.95,359.95,63.10,383.90,16.75,424.60,14.35,467.70,-11.15,494.80,-11.15];
	}
	const sprite = this.sprite;
	NellieBlyCutouts_blyPlaygroundBg.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1708.00;
	sprite.height = 998.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function NellieBlyCutouts_Symbol46(this: INellieBlyCutouts_Symbol46) {
	return this;
}
function NellieBlyCutouts_blyPlaygroundBg(this: INellieBlyCutouts_blyPlaygroundBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-playground-bg.png", 0.000, 0.000);
	return this;
}
interface INellieBlyCutoutsArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface INellieBlyCutoutsContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface INellieBlyCutoutsSprite extends INellieBlyCutoutsContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface INellieBlyCutoutsText extends INellieBlyCutoutsContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface INellieBlyCutoutsPolygon extends Array<number> {
}
interface INellieBlyCutouts {
	readonly cutouts: INellieBlyCutoutsArray<INellieBlyCutouts_blyBalloon_cutout|INellieBlyCutouts_blyBike_cutout|INellieBlyCutouts_blyBirdBack_cutout|INellieBlyCutouts_blyDrZoom_cutout|INellieBlyCutouts_blyDrZoom1_cutout|INellieBlyCutouts_blyDuck_cutout|INellieBlyCutouts_blyGust_cutout|INellieBlyCutouts_blyKite_cutout|INellieBlyCutouts_blyLandingPad_cutout|INellieBlyCutouts_blyMonkeyBars_cutout|INellieBlyCutouts_blyMonkeyBars1_cutout|INellieBlyCutouts_blyMoon1_cutout|INellieBlyCutouts_blyMoon2_cutout|INellieBlyCutouts_blyMoon3_cutout|INellieBlyCutouts_blyPlayground1_cutout|INellieBlyCutouts_blyPlayground2_cutout|INellieBlyCutouts_blyPlayground3_cutout|INellieBlyCutouts_blyPlayground4_cutout|INellieBlyCutouts_blyPyramid_cutout|INellieBlyCutouts_blyRollerskate_cutout|INellieBlyCutouts_blySeesaw_cutout|INellieBlyCutouts_blySlideBack_cutout|INellieBlyCutouts_blySlideFront_cutout|INellieBlyCutouts_blySpaghetti_cutout|INellieBlyCutouts_blySwing_cutout|INellieBlyCutouts_blyYBoat_cutout|INellieBlyCutouts_blyYClimb_cutout|INellieBlyCutouts_blyYDuck_cutout|INellieBlyCutouts_blyYHero_cutout|INellieBlyCutouts_blyYHug_cutout|INellieBlyCutouts_blyYJetpack_cutout|INellieBlyCutouts_blyYKiss_cutout|INellieBlyCutouts_blyYRawr_cutout|INellieBlyCutouts_blyYReachout_cutout|INellieBlyCutouts_blyYSeesaw_cutout|INellieBlyCutouts_blyYSlide_cutout|INellieBlyCutouts_blyYSnack_cutout|INellieBlyCutouts_blyYSnackDrzoom_cutout|INellieBlyCutouts_blyYSwing_cutout|INellieBlyCutouts_blyPizzastairs_cutout|INellieBlyCutouts_blyLadder_cutout|INellieBlyCutouts_blyPlaygroundBg_cutout>;
}
interface INellieBlyCutouts_blyBalloon_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol1>;
	readonly sprite: INellieBlyCutouts_blyBalloon;
}
interface INellieBlyCutouts_Symbol1 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyBalloon extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyBike_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol2>;
	readonly sprite: INellieBlyCutouts_blyBike;
}
interface INellieBlyCutouts_Symbol2 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyBike extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyBirdBack_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol3>;
	readonly sprite: INellieBlyCutouts_blyBirdBack;
}
interface INellieBlyCutouts_Symbol3 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyBirdBack extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyDrZoom_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol4>;
	readonly sprite: INellieBlyCutouts_blyDrZoom;
}
interface INellieBlyCutouts_Symbol4 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyDrZoom extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyDrZoom1_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol5>;
	readonly sprite: INellieBlyCutouts_blyDrZoom1;
}
interface INellieBlyCutouts_Symbol5 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyDrZoom1 extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyDuck_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol6>;
	readonly sprite: INellieBlyCutouts_blyDuck;
}
interface INellieBlyCutouts_Symbol6 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyDuck extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyGust_cutout extends INellieBlyCutoutsContainer {
	readonly sprite: INellieBlyCutouts_blyGust;
}
interface INellieBlyCutouts_blyGust extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyKite_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol7>;
	readonly sprite: INellieBlyCutouts_blyKite;
}
interface INellieBlyCutouts_Symbol7 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyKite extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyLandingPad_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol8>;
	readonly sprite: INellieBlyCutouts_blyLandingPad;
}
interface INellieBlyCutouts_Symbol8 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyLandingPad extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyMonkeyBars_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol40|INellieBlyCutouts_Symbol41>;
	readonly sprite: INellieBlyCutouts_blyMonkeyBars;
}
interface INellieBlyCutouts_Symbol40 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_Symbol41 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyMonkeyBars extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyMonkeyBars1_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol42|INellieBlyCutouts_Symbol43>;
	readonly sprite: INellieBlyCutouts_blyMonkeyBars1;
}
interface INellieBlyCutouts_Symbol42 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_Symbol43 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyMonkeyBars1 extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyMoon1_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol11>;
	readonly sprite: INellieBlyCutouts_blyMoon1;
}
interface INellieBlyCutouts_Symbol11 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyMoon1 extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyMoon2_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol12>;
	readonly sprite: INellieBlyCutouts_blyMoon2;
}
interface INellieBlyCutouts_Symbol12 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyMoon2 extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyMoon3_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol13>;
	readonly sprite: INellieBlyCutouts_blyMoon3;
}
interface INellieBlyCutouts_Symbol13 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyMoon3 extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyPlayground1_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol14|INellieBlyCutouts_Symbol45>;
	readonly sprite: INellieBlyCutouts_blyPlayground1;
}
interface INellieBlyCutouts_Symbol14 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_Symbol45 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyPlayground1 extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyPlayground2_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol15>;
	readonly sprite: INellieBlyCutouts_blyPlayground2;
}
interface INellieBlyCutouts_Symbol15 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyPlayground2 extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyPlayground3_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol16>;
	readonly sprite: INellieBlyCutouts_blyPlayground3;
}
interface INellieBlyCutouts_Symbol16 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyPlayground3 extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyPlayground4_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol17>;
	readonly sprite: INellieBlyCutouts_blyPlayground4;
}
interface INellieBlyCutouts_Symbol17 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyPlayground4 extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyPyramid_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol18>;
	readonly sprite: INellieBlyCutouts_blyPyramid;
}
interface INellieBlyCutouts_Symbol18 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyPyramid extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyRollerskate_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol19>;
	readonly sprite: INellieBlyCutouts_blyRollerskate;
}
interface INellieBlyCutouts_Symbol19 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyRollerskate extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blySeesaw_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol20>;
	readonly sprite: INellieBlyCutouts_blySeesaw;
}
interface INellieBlyCutouts_Symbol20 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blySeesaw extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blySlideBack_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol21>;
	readonly sprite: INellieBlyCutouts_blySlideBack;
}
interface INellieBlyCutouts_Symbol21 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blySlideBack extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blySlideFront_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol22>;
	readonly sprite: INellieBlyCutouts_blySlideFront;
}
interface INellieBlyCutouts_Symbol22 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blySlideFront extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blySpaghetti_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol23>;
	readonly sprite: INellieBlyCutouts_blySpaghetti;
}
interface INellieBlyCutouts_Symbol23 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blySpaghetti extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blySwing_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol25|INellieBlyCutouts_Symbol24>;
	readonly sprite: INellieBlyCutouts_blySwing;
}
interface INellieBlyCutouts_Symbol25 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_Symbol24 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blySwing extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYBoat_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol26>;
	readonly sprite: INellieBlyCutouts_blyYBoat;
}
interface INellieBlyCutouts_Symbol26 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYBoat extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYClimb_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol27>;
	readonly sprite: INellieBlyCutouts_blyYClimb;
}
interface INellieBlyCutouts_Symbol27 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYClimb extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYDuck_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol47>;
	readonly sprite: INellieBlyCutouts_blyYDuck;
}
interface INellieBlyCutouts_Symbol47 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYDuck extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYHero_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol29>;
	readonly sprite: INellieBlyCutouts_blyYHero;
}
interface INellieBlyCutouts_Symbol29 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYHero extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYHug_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol30>;
	readonly sprite: INellieBlyCutouts_blyYHug;
}
interface INellieBlyCutouts_Symbol30 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYHug extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYJetpack_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol31>;
	readonly sprite: INellieBlyCutouts_blyYJetpack;
}
interface INellieBlyCutouts_Symbol31 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYJetpack extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYKiss_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol32>;
	readonly sprite: INellieBlyCutouts_blyYKiss;
}
interface INellieBlyCutouts_Symbol32 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYKiss extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYRawr_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol33>;
	readonly sprite: INellieBlyCutouts_blyYRawr;
}
interface INellieBlyCutouts_Symbol33 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYRawr extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYReachout_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol34>;
	readonly sprite: INellieBlyCutouts_blyYReachout;
}
interface INellieBlyCutouts_Symbol34 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYReachout extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYSeesaw_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol35>;
	readonly sprite: INellieBlyCutouts_blyYSeesaw;
}
interface INellieBlyCutouts_Symbol35 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYSeesaw extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYSlide_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol36>;
	readonly sprite: INellieBlyCutouts_blyYSlide;
}
interface INellieBlyCutouts_Symbol36 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYSlide extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYSnack_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol37>;
	readonly sprite: INellieBlyCutouts_blyYSnack;
}
interface INellieBlyCutouts_Symbol37 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYSnack extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYSnackDrzoom_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol38>;
	readonly sprite: INellieBlyCutouts_blyYSnackDrzoom;
}
interface INellieBlyCutouts_Symbol38 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYSnackDrzoom extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyYSwing_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol28|INellieBlyCutouts_Symbol48>;
	readonly sprite: INellieBlyCutouts_blyYSwing;
}
interface INellieBlyCutouts_Symbol28 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_Symbol48 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyYSwing extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyPizzastairs_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol9>;
	readonly sprite: INellieBlyCutouts_blyPizzastairs;
}
interface INellieBlyCutouts_Symbol9 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyPizzastairs extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyLadder_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol10|INellieBlyCutouts_Symbol44>;
	readonly sprite: INellieBlyCutouts_blyLadder;
}
interface INellieBlyCutouts_Symbol10 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_Symbol44 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyLadder extends INellieBlyCutoutsSprite {
}
interface INellieBlyCutouts_blyPlaygroundBg_cutout extends INellieBlyCutoutsContainer {
	readonly polygons: INellieBlyCutoutsArray<INellieBlyCutouts_Symbol46>;
	readonly sprite: INellieBlyCutouts_blyPlaygroundBg;
}
interface INellieBlyCutouts_Symbol46 extends INellieBlyCutoutsPolygon {
}
interface INellieBlyCutouts_blyPlaygroundBg extends INellieBlyCutoutsSprite {
}
